import React, { useState, useEffect } from 'react';
import { getMenuItems, getContactMessages } from '../../services/api';
import { getUsers } from '../../services/adminApi';
import { useAuth } from '../../contexts/AuthContext';
import { Package, Users, MessageSquare, Star } from 'lucide-react';

const DashboardHome = () => {
  const { isSuperAdmin } = useAuth();
  const [stats, setStats] = useState({
    totalItems: 0,
    totalUsers: 0,
    unreadMessages: 0,
    featuredItems: 0
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const items = await getMenuItems();
        
        let messages = [];
        try {
          messages = await getContactMessages();
        } catch (error) {
          console.log('Could not fetch messages:', error);
        }

        let users = [];
        if (isSuperAdmin) {
          try {
            users = await getUsers();
          } catch (error) {
            console.log('Could not fetch users:', error);
          }
        }

        setStats({
          totalItems: items.length,
          totalUsers: users.length,
          unreadMessages: messages.filter(m => !m.read).length,
          featuredItems: items.filter(i => i.featured).length
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    };

    fetchStats();
  }, [isSuperAdmin]);

  const statCards = [
    {
      title: 'Total Menu Items',
      value: stats.totalItems,
      icon: Package,
      color: 'bg-pink-500'
    },
    {
      title: 'Featured Items',
      value: stats.featuredItems,
      icon: Star,
      color: 'bg-teal-500'
    },
    {
      title: 'Unread Messages',
      value: stats.unreadMessages,
      icon: MessageSquare,
      color: 'bg-purple-500'
    }
  ];

  if (isSuperAdmin) {
    statCards.push({
      title: 'Total Users',
      value: stats.totalUsers,
      icon: Users,
      color: 'bg-blue-500'
    });
  }

  return (
    <div>
      <h2 className="text-3xl font-black mb-8">Dashboard Overview</h2>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat, index) => (
          <div key={index} className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div className={`${stat.color} p-3 rounded-xl`}>
                <stat.icon className="w-6 h-6 text-white" />
              </div>
            </div>
            <div>
              <p className="text-gray-600 text-sm font-semibold mb-1">{stat.title}</p>
              <p className="text-4xl font-black">{stat.value}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-white rounded-2xl shadow-lg p-8">
        <h3 className="text-2xl font-black mb-4">Welcome to Your Admin Dashboard!</h3>
        <p className="text-gray-700 mb-4">
          Use the sidebar to navigate through different sections:
        </p>
        <ul className="space-y-2 text-gray-700">
          <li><strong>Menu Items:</strong> Add, edit, or remove menu items with prices and images</li>
          <li><strong>Specials:</strong> Manage featured and famous items</li>
          <li><strong>Messages:</strong> View and respond to customer inquiries</li>
          {isSuperAdmin && (
            <li><strong>Users:</strong> Manage admin users (Super Admin only)</li>
          )}
          <li><strong>Settings:</strong> Update contact information and site settings</li>
        </ul>
      </div>
    </div>
  );
};

export default DashboardHome;
